import { useSearchParams } from 'react-router-dom'
import { light } from '@fortawesome/fontawesome-svg-core/import.macro'

import { Card, CardColors, Icon, Image, List, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

const HeardListItem = ({ contentText }: { contentText: string }) => (
  <List.Item className="flex items-center gap-1">
    <Icon color="text-green-100" size="2x" icon={light('check')} />
    <Text className="flex-1">{contentText}</Text>
  </List.Item>
)

export const WhatYouGetCard = ({ className }: { className?: string }) => {
  const [searchParams] = useSearchParams()
  const basicPlanSearchParamValue = searchParams.get('subscription')
  const useBasicNoQtePlan = basicPlanSearchParamValue === 'basic'
  const useBasicPlan = basicPlanSearchParamValue === 'new'
  const useAnyBasicPlan = useBasicPlan || useBasicNoQtePlan

  return (
    <Card className={`p-12 ${className}`} color={CardColors.LEVEL_1}>
      <Text variant={TypographyStyles.H2}>What you get with Heard</Text>

      <List className="mt-8">
        <HeardListItem contentText="Tax pros who specialize in therapy practices" />

        {!useAnyBasicPlan && (
          <HeardListItem contentText="Annual personal and professional income tax filing, state and federal" />
        )}

        {!useBasicNoQtePlan && (
          <HeardListItem contentText="Quarterly tax estimates" />
        )}

        <HeardListItem contentText="Monthly bookkeeping and financial reports" />
        <HeardListItem contentText="Anytime messaging support" />

        <List.Item className="flex items-center gap-4 mt-10 ml-4">
          <Image
            className="w-12 h-12 rounded-full"
            aspectRatio="1/1"
            src="https://heard-images.s3.amazonaws.com/assets/signup/therapist-profile-pic-2.jpg"
            alt="Michelle Vo"
          />

          <div>
            <Text variant={TypographyStyles.H3}>Michelle Vo</Text>
            <Text variant={TypographyStyles.BODY_SM}>LCSW</Text>
          </div>
        </List.Item>

        <List.Item className="mt-2.5 text-center">
          <Text
            variant={TypographyStyles.BODY_SM}
            textAlign="center"
            color={TextColors.MUTED}
          >
            &ldquo;Heard has supported my business in more ways than I can
            express! Since partnering with them in 2021, they&apos;ve provided
            invaluable assistance with my personal tax returns, quarterly tax
            filings, and establishing payroll for my S Corporation&rdquo;
          </Text>
        </List.Item>
      </List>
    </Card>
  )
}
